import React, {Component} from 'react';

export default class Dropdown extends Component {

  constructor(props) {
    super(props);
    this.state = {
      autoCompleteValue: '',
      listVisible: false,
      selectedItem: this.props.selected && this.props.selected.id ? this.props.selected : this.props.items[0]
    }
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) this.setState({ listVisible : false });
  }

  update(item, removeAutoComplete) {
    let data = { selectedItem: item };
    if (removeAutoComplete) data.autoCompleteValue = '';
    this.setState(data);
  }

  show() {
    this.setState({listVisible: true});
  }

  render() {
    let _self = this;
    return <div ref={this.setWrapperRef} className={'c-dropdown' + (this.props.forceActive || this.props.items.length > 1 || (_self.props.autocomplete && _self.state.autoCompleteValue !== '') ? ' active' : '')}>
      <div onClick={() => { if(this.props.items.length > 1) _self.setState({listVisible : !_self.state.listVisible}); }} className="c-dropdown-label">
        {_self.props.autocomplete && <input readOnly={_self.props.readOnly} value={_self.state.autoCompleteValue} placeholder={this.state.selectedItem.label} type="text" onChange={ev => { 
          _self.setState({ autoCompleteValue: ev.target.value }, function() { 
            _self.props.autocomplete(_self.state.autoCompleteValue); 
          }); }} />}
        {!_self.props.autocomplete && <span className={'truncate'}>{this.props.text}<b dangerouslySetInnerHTML={{__html: this.state.selectedItem.label}}></b></span>}
        <img alt="" src="/static/imgs/angle-right.svg" className={this.props.noIcon ? 'hide' : ''} />
      </div>
      <ul className={'c-dropdown-list' + (this.state.listVisible ? '' : ' hide')}>
        {this.props.items.slice(1).map((item, i) =>
          {return item.label && <li onClick={() => { _self.setState({listVisible : false, selectedItem: item});_self.props.getItem(item); }} data-id={item.id} key={i}>
            <i className={item.icon ? ('fas fa-' + item.icon) : 'hide'}></i>
            <span>{item.label}</span>
          </li>}
        )}
      </ul>
    </div>
  }

}


// WEBPACK FOOTER //
// ./src/containers/base/dropdown.js